import { render, staticRenderFns } from "./newlist.vue?vue&type=template&id=f3872258&"
import script from "./newlist.vue?vue&type=script&lang=js&"
export * from "./newlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports